<script>
import Story0 from "../story/story0.vue";
import gsap from 'gsap'
import { ScrollTrigger } from "gsap/ScrollTrigger"
import { ScrollToPlugin } from "gsap/ScrollToPlugin"
gsap.registerPlugin(ScrollTrigger)
// gsap.registerPlugin(GSDevTools)
gsap.registerPlugin(ScrollToPlugin)
ScrollTrigger.observe({
  trigger: 'body',
  type: "touch, pointer",
  onChange: () => {
    ScrollTrigger.update()
  }
})
function loadImage(url) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = reject;
    img.src = url;
  });
}
function loadMultipleImage (urls, callback = () => {}) {
  Promise.all(urls.map(loadImage)).then(images => {
    callback()
  }).catch(error => {
    console.error(error)
  })
}
import storyData from "../components/story-data";
import AudioIcon from "../components/audioIcon.vue";
export default {
  name: "scrollPage",
  components: {AudioIcon, Story0},
  data () {
    return {
      gsap,
      showPage: false,
      audioStatus: false,
      isFirstTouch: true,
      audioUrl: 'https://rmt.imugeda.com/c/scpy/_5qj/audios/66a313989cbaff52af0331bf.mp3',
      btnImageUrl: 'https://hbrbapp.hubeidaily.net/h5/file.png',
      // videoUrl: 'https://hbrbapp.hubeidaily.net/h5/%E6%95%85%E4%BA%8B1.mp4',
      // videoPostUrl: 'https://hbrbapp.hubeidaily.net/h5/2222.png',
      // photoImageUrl: 'https://rmt.imugeda.com/c/ietf/step/images/66d8522980af6ae5c60881df.jpg',
      // backgroundImageUrl: 'https://hbrbapp.hubeidaily.net/h5/family-photo/01%20%281%29.png',
      fuImageUrl: 'https://hbrbapp.hubeidaily.net/h5/family-photo/172674379651359.gif',
      fuImageScale: 0.5,
      showVideoBtn: false,
      // fuImageUrl: 'https://hbrbapp.hubeidaily.net/h5/family-photo/%E5%8D%A1%E9%80%9A%E7%A6%8F.png',
      pageData: []
    }
  },
  mounted () {
    this.pageData = storyData.data
    // 做一些修正
    const correctValue = 14
    this.pageData.forEach((story, index) => {
      if (index >= 2) {
        story.photoPosition.y -= correctValue
        story.firstPathList.forEach(item => {
          item.y -= correctValue
        })
        story.secondPathList.forEach(item => {
          item.y -= correctValue
        })
      }
    })
    loadMultipleImage([this.fuImageUrl, this.btnImageUrl], () => {
      this.preStoryPage(0)
    })

    // setTimeout(() => {
    //   let heights = 0
    //   for (let i = 0; i < this.$refs.story.length - 1; i ++) {
    //     heights += this.$refs.story[i].$el.getBoundingClientRect().height
    //   }
    //   this.$refs.scrollContainer.scrollTop = heights
    //   console.log(heights)
    // }, 2000)
  },
  methods: {
    // preLoadImage (imageUrl, callback = () => {}) {
    //   const img = new Image()
    //   img.src = imageUrl
    //   img.onload = () => {
    //     callback()
    //   }
    // },
    preStoryPage (index) {
      if (index >= this.pageData.length) {
        return
      }
      const imageUrls = [this.pageData[index].backgroundImageUrl, this.pageData[index].photoImageUrl, this.pageData[index].videoPostUrl]
      loadMultipleImage(imageUrls, () => {
        if (index === 0) {
          this.showPage = true
          this.$nextTick(() => {
            this.initScroll()
          })
        }
        this.$nextTick(() => {
          this.$refs.story[index].imageFallen()
        })
        this.preStoryPage(index + 1)
      })
    },
    initScroll () {
      const container = this.$refs.scrollContainer
      // 设置滚动速度倍率（例如，滚动速度为默认的2倍）
      const scrollSpeedMultiplier = 1.4
      let startY = 0 // 记录初始触摸位置
      container.addEventListener('touchstart', (event) => {
        // console.log('21212121')
        // 记录初始触摸位置
        if (this.isFirstTouch) {
          this.$refs.audioIcon.onIconClick()
          this.isFirstTouch = false
        }
        startY = event.touches[0].clientY
      })
      container.addEventListener('touchmove', (event) => {
        // 阻止默认的滚动行为
        event.preventDefault()
        // 获取当前触摸位置
        const currentY = event.touches[0].clientY
        // 计算触摸的移动距离
        const deltaY = (currentY - startY) * scrollSpeedMultiplier
        // 计算新的滚动位置
        // 设置新的滚动位置
        container.scrollTop = container.scrollTop - deltaY
        // 更新初始触摸位置
        startY = currentY
      })
      container.addEventListener('touchend', (event) => {
        startY = 0
      })
    },
    getPosition () {
      const story0 = [
        {
          x: 22,
          y: 280
        },
        {
          x: 88,
          y: 340
        },
        {
          x: 13,
          y: 413
        },
        {
          x: 67,
          y: 492
        }
      ]
    },
    onBtnShowChange (val) {
      this.showVideoBtn = val
    },
    onBackgroundClick (event) {
      const container = this.$refs.scrollContainer
      console.log(container.scrollTop)
      const clickX = event.clientX
      const clickY = event.clientY
      const distanceToTop = clickY + container.scrollTop
      const distanceToLeft = clickX
      const vwDistance = window.innerWidth / 100
      console.log(distanceToLeft / vwDistance, distanceToTop / vwDistance, '-----')
      console.log(distanceToLeft, distanceToTop, window.innerWidth)
      console.log(event)
    },
    onAudioChange (val) {
      this.audioStatus = val
    },
    onStopVideo () {
      console.log('停止播放视频')
      const audio = document.getElementById('basicAudio')
      if (audio.paused) {
        this.$refs.audioIcon.onIconClick()
      }
    },
    onPauseVideo () {
      console.log('暂停播放视频')
      const audio = document.getElementById('basicAudio')
      if (audio.paused) {
        this.$refs.audioIcon.onIconClick()
      }
    },
    onPlayVideo () {
      this.$refs.audioIcon.onIconClick()
      console.log('播放视频')
    }
  }
}
</script>

<template>
  <div class="main-page" ref="scrollContainer" v-if="showPage">
    <audio-icon :audio-url="audioUrl" :status="audioStatus" ref="audioIcon" class="audio-icon" @change="onAudioChange"></audio-icon>
    <story0
      v-for="(item, index) in pageData"
      :key="index"
      ref="story"
      :gsap="gsap"
      :index="index"
      :btn-image-url="btnImageUrl"
      :video-url="item.videoUrl"
      :fu-image-url="fuImageUrl"
      :video-post-url="item.videoPostUrl"
      :photo-image-url="item.photoImageUrl"
      :background-image-url="item.backgroundImageUrl"
      :first-path-list="item.firstPathList"
      :second-path-list="item.secondPathList"
      :photo-position="item.photoPosition"
      :photo-top="item.photoTop"
      :photo-mask-position="item.photoMaskPosition"
      :areaInfo="item.areaInfo"
      :post-to-top="item.postToTop"
      :photo-height="item.photoHeight"
      :fu-image-scale="fuImageScale"
      @background-click="onBackgroundClick"
      @btn-show-change="onBtnShowChange"
      @stop-video="onStopVideo"
      @pause-video="onPauseVideo"
      @play-video="onPlayVideo"
    >
    </story0>
    <img class="fu-image" :src="fuImageUrl">
<!--    <img style="display: block; width: 100%; " class="background-image" src="https://rmt.imugeda.com/c/ietf/step/images/66d827bce28b1bae2d0bfc6b.jpg">-->
  </div>
</template>

<style scoped lang="scss">
.main-page {
  // 隐藏滚动条
  background: #c8f2ff;
  position: relative;
  scrollbar-width: none;
  height: 100%;
  width: 100%;
  overflow-y: scroll;
  &::-webkit-scrollbar{
    display: none;
  }
}
.main-page * {
  touch-action: auto;
}
.fu-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 35%;
  z-index: 999;
}
.audio-icon {
  position: fixed;
  right: 2vw;
  top: 2vw;
  z-index: 1;
  width: 10vw;
}
</style>